<template>
	<div v-parallax-fit="parallax" class="slide-magazin" id="slidemagazin-1">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/06_SeniorAds@2x.png">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/henry/3.srt',
				'es': '/themes/rise-theme/resources/assets/audio/henry/3_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 12000,
					end: 13000,
					fromStyle: { opacity: 0 },
					toStyle: { opacity: 1 },
					easing: 'linear'
				},
				{
					start: 13000,
					end: 16000,
					fromStyle: { transform: 'translateY(0%)', opacity: 1 },
					toStyle: { transform: 'translateY(300%)', opacity: 1 },
					easing: 'linear'
				}
			]
		}
	},
	created() {
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const audio = '/themes/rise-theme/resources/assets/audio/henry/3.mp3';

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.opacity == 1) {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
				}
			});
		});

		this.mutationObserver.observe(document.querySelector('#slidemagazin-1'), {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
}
</script>

<style lang="scss" scoped>
.slide-magazin {
	position: absolute;
	top: -10%;
	left: 0;
	transition: all 0.1s linear;
}
</style>
